// @flow
import type { Action } from '../actions/types';
import {
	FETCH_PAYMENT_METHODS,
	FETCH_PAYMENT_METHODS_SUCCESS,
	FETCH_PAYMENT_METHODS_ERROR,
	LINK_PAYMENT_SEND_OTP_SUCCESS,
	SELECT_PAYMENT_METHOD,
	MAKE_PAYMENT,
	PAYMENT_SUCCESS,
	PAYMENT_ERROR,
	RESET_PAYMENT,
	PAYTM_ADD_MONEY_RES,
	OPEN_CARD_CVV,
	LINK_PAYMENT_METHOD_SUCCESS,
	SET_PAYMENT,
	CAPTURE_PAYMENT,
	FETCH_PENDING_BALANCE,
	FETCH_PENDING_BALANCE_SUCCESS,
	FETCH_PENDING_BALANCE_ERROR,
	NEUU_WALLET_MAKE_PAYMENT,
	DEBOUNCE_FETCH_PAYMENT_METHODS,
	POOL_PAYMENT_STATUS,
	CANCEL_POOL_PAYMENT_STATUS,
	POOL_WALLET_LOAD,
	UPI_COLLECT_PAYMENT,
	SELECTED_PAYMENT_ERROR,
	RESET_VERIFICATION,
	EDIT_UPI_VPA,
	CLEAR_UPI_VPA,
	CLEAR_UPI_VPA_SUCCESS,
	CLEAR_UPI_VPA_ERROR,
	LOAD_WALLET_UPI,
	SHOW_PAYMENT_GATEWAY,
} from '../actions/types';

export type PaymentState = {
	fetching: boolean,
	paymentMethods: Array<any>,
	selectedPayment: any,
	error: any | null,
	processingPayment: boolean,
	processedPayment: boolean,
	processedPaymentData: {} | null,
	fetchedPendingBalance: boolean,
	pendingBalance: number,
	isPooling: boolean,
	cancelPooling: boolean,
	verifyingPayment: boolean,
	clearingVpa: boolean,
	transactionValue: number,
	orderId: string | null,
	deliveryFee: number,
	showPaymentGateway: boolean,
};

const initialState = {
	fetching: false,
	paymentMethods: [],
	selectedPayment: null,
	error: null,
	processingPayment: false,
	processedPayment: false,
	processedPaymentData: null,
	fetchedPendingBalance: false,
	pendingBalance: 0,
	isPooling: false,
	cancelPooling: false,
	verifyingPayment: false,
	clearingVpa: false,
	transactionValue: 0,
	orderId: null,
	deliveryFee: 0,
	showPaymentGateway: false,
};

export const paymentReducer = (state: PaymentState = initialState, action: Action) => {
	switch (action.type) {
		case FETCH_PAYMENT_METHODS:
			return {
				...state,
				selectedPayment: null,
				error: null,
				processingPayment: false,
				processedPayment: false,
				processedPaymentData: null,
				fetching: true,
				paymentMethods: [],
				verifyingPayment: false,
				showPaymentGateway: false,
			};

		case FETCH_PAYMENT_METHODS_SUCCESS:
			const { paymentMethods = [], amount = 0, orderId, deliveryFee = 0 } = action.payload || {};
			return {
				...state,
				fetching: false,
				paymentMethods: paymentMethods,
				transactionValue: amount,
				orderId,
				deliveryFee,
			};

		case FETCH_PAYMENT_METHODS_ERROR:
			return {
				...state,
				fetching: false,
				paymentMethods: [],
				error: action.payload,
			};

		case OPEN_CARD_CVV:
		case LINK_PAYMENT_SEND_OTP_SUCCESS:
		case EDIT_UPI_VPA:
			return {
				...state,
				paymentMethods: updateOpenLinkContainer(state.paymentMethods, action.payload),
			};

		case LINK_PAYMENT_METHOD_SUCCESS:
			return {
				...state,
				paymentMethods: processLinkPayment(state.paymentMethods, action.payload),
			};

		case SELECT_PAYMENT_METHOD:
			return {
				...state,
				selectedPayment: action.payload,
			};

		case MAKE_PAYMENT:
		case CAPTURE_PAYMENT:
		case NEUU_WALLET_MAKE_PAYMENT:
			return {
				...state,
				processingPayment: true,
				processedPayment: false,
				error: null,
			};

		case PAYMENT_SUCCESS:
			return {
				...state,
				processingPayment: false,
				processedPayment: true,
				processedPaymentData: action.payload,
				error: null,
				isPooling: false,
				verifyingPayment: false,
				showPaymentGateway: false,
			};

		case SHOW_PAYMENT_GATEWAY:
			//console.log("reducers::SHOW_PAYMENT_GATEWAY: ");
			//console.log(action.payload)
			//console.log(state)
			return {
				...state,
				showPaymentGateway: true,
				paymentGatewayData: action.payload.pg_data,
				//FIXME: Hack: Used for load wallet using razorPay. Move to order reducer
				//1. Add new state variable storing load_wallet_order_id.
				//2. Add new action SET_LOAD_WALLET_ORDER_ID or equivalent
				order_id: action.payload.order_id,
			};

		case PAYMENT_ERROR:
			return {
				...state,
				// selectedPayment: null,
				processingPayment: false,
				processedPayment: true,
				processedPaymentData: null,
				error: action.payload,
				isPooling: false,
				cancelPooling: false,
				verifyingPayment: false,
				showPaymentGateway: false,
			};

		case RESET_PAYMENT:
			return {
				...state,
				selectedPayment: null,
				processingPayment: false,
				processedPayment: false,
				processedPaymentData: null,
				error: null,
				isPooling: false,
				cancelPooling: false,
				verifyingPayment: false,
				transactionValue: 0,
				orderId: null,
				showPaymentGateway: false,
			};

		case PAYTM_ADD_MONEY_RES:
			return {
				...state,
				processingPayment: true,
				processedPayment: false,
				processedPaymentData: null,
				error: null,
			};

		case SET_PAYMENT:
			return {
				...state,
				...action.payload,
			};

		case FETCH_PENDING_BALANCE:
			return {
				...state,
				fetchedPendingBalance: false,
				pendingBalance: 0,
				error: null,
			};

		case FETCH_PENDING_BALANCE_SUCCESS:
			return {
				...state,
				fetchedPendingBalance: true,
				pendingBalance: action.payload,
			};

		case FETCH_PENDING_BALANCE_ERROR:
			return {
				...state,
				fetchedPendingBalance: true,
				pendingBalance: 0,
				error: action.payload,
			};

		case DEBOUNCE_FETCH_PAYMENT_METHODS:
			return {
				...state,
				selectedPayment: null,
				error: null,
				processingPayment: false,
				processedPayment: false,
				processedPaymentData: null,
				fetching: true,
				showPaymentGateway: false,
				// paymentMethods: []
			};

		case POOL_PAYMENT_STATUS:
			return {
				...state,
				isPooling: true,
				selectedPayment: {
					...state.selectedPayment,
					upiUrl: action.payload && action.payload.upiUrl,
				},
			};

		case CANCEL_POOL_PAYMENT_STATUS:
			return {
				...state,
				cancelPooling: true,
			};

		//for wallet load purpose
		case POOL_WALLET_LOAD:
			return {
				...state,
				selectedPayment: {
					...state.selectedPayment,
					upiUrl: action.payload && action.payload.upiUrl,
				},
			};

		case UPI_COLLECT_PAYMENT:
		case LOAD_WALLET_UPI:
			return {
				...state,
				verifyingPayment: true,
				selectedPayment: {
					...(action.payload ? action.payload.paymentMethod : {}),
					verifying: true,
					editVpa: true,
				},
			};

		case SELECTED_PAYMENT_ERROR:
			return {
				...state,
				verifyingPayment: false,
				selectedPayment: {
					...state.selectedPayment,
					editVpa: true,
					verifying: false,
					error: action.payload,
				},
			};

		case RESET_VERIFICATION:
			return {
				...state,
				verifyingPayment: false,
				selectedPayment: {
					...state.selectedPayment,
					verifying: false,
					error: null,
				},
			};

		case CLEAR_UPI_VPA:
			return {
				...state,
				clearingVpa: true,
			};

		case CLEAR_UPI_VPA_SUCCESS:
			return {
				...state,
				clearingVpa: false,
				paymentMethods: clearUpiId(state.paymentMethods, action.payload),
			};

		case CLEAR_UPI_VPA_ERROR:
			return {
				...state,
				clearingVpa: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

const updateOpenLinkContainer = (paymentMethods, { paymentMethod: selectedPaymentMethod, state } = {}): Array<{}> => {
	return paymentMethods.map((paymentMethod) => {
		return {
			...paymentMethod,
			openLinkContainer: paymentMethod === selectedPaymentMethod,
			state,
		};
	});
};

const clearUpiId = (paymentMethods, selectedPaymentMethod): Array<{}> => {
	if (!selectedPaymentMethod) {
		return paymentMethods;
	}

	const index = paymentMethods.findIndex((payMethod) => payMethod.id === selectedPaymentMethod.id);
	if (index >= 0) {
		paymentMethods[index] = selectedPaymentMethod;
	}

	return [...paymentMethods];
};

const processLinkPayment = (paymentMethods, selPaymentMethod): Array<any> => {
	if (!selPaymentMethod) {
		return paymentMethods;
	}

	return paymentMethods.map((paymentMethod) => {
		if (paymentMethod.name === selPaymentMethod.name) {
			return selPaymentMethod;
		}

		return paymentMethod;
	});
};
